import React from 'react';

const CategoryHeader = ({ category, categoryHeaderOverride }) => {
    if (categoryHeaderOverride) {
        return categoryHeaderOverride;
    }
    // Default category header
    return (React.createElement("div", { id: "category-header", className: "ctg-header" },
        React.createElement("div", { className: "stack" },
            React.createElement("h1", { className: "name" },
                React.createElement("span", null, category.name)),
            React.createElement("div", { className: "description", dangerouslySetInnerHTML: { __html: category.description } }))));
};

export { CategoryHeader as C };
//# sourceMappingURL=CategoryHeader-s-kLV-J5.js.map
